<div class="h4">EGift allows your guests to purchase digital gift cards from your website. Cards can be sent to a friend or to the purchaser.</div>
<div class="p-grid">
	<div class="p-col-12 p-md-4">
		<div class="d-flex">
			<div class="h3">Service Setup</div>
		</div>
		<p-divider></p-divider>
		<div class="mb-4">
			<div>EGift Enabled</div>
			<p-inputSwitch #eGiftEnabled [(ngModel)]="eGiftVenue.enabled" (onChange)="changesToSaveChange.emit(true)"> </p-inputSwitch>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<textarea
					#headerMessageText
					pInputTextarea
					[(ngModel)]="eGiftVenue.headerMessage"
					[maxlength]="500"
					style="height: 100px; width: 100%"
					(change)="changesToSaveChange.emit(true)"
				></textarea>
				<label for="headerMessageText">Header message</label>
			</span>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<textarea
					#footerMessageText
					pInputTextarea
					[(ngModel)]="eGiftVenue.footerMessage"
					[maxlength]="500"
					style="height: 100px; width: 100%"
					(change)="changesToSaveChange.emit(true)"
				></textarea>
				<label for="footerMessageText">Footer Message</label>
			</span>
		</div>
		<div class="mt-4" *ngIf="venueService.subscriptionOOmenuItems.value">
			<span class="p-float-label">
				<p-dropdown
					#eGiftMenuItem
					placeholder="Gift Card Menu Item"
					[options]="venueService.subscriptionOOmenuItems.value"
					optionLabel="name"
					optionValue="menuItemKey"
					name="menuItemList"
					[(ngModel)]="eGiftVenue.menuItemKey"
					[virtualScroll]="true"
					virtualScrollItemSize="30"
					[filter]="true"
					filterBy="name,displayName"
					[style]="{ width: '100%' }"
					appendTo="body"
					(onChange)="changesToSaveChange.emit(true)"
				>
				</p-dropdown>
				<label for="eGiftMenuItem">EGift Menu Item</label>
			</span>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="d-flex">
			<div class="h3">Email Setup</div>
		</div>
		<p-divider></p-divider>
		<div class="mt-4">
			<span class="p-float-label">
				<input
					#emailVenueNameText
					pInputText
					type="text"
					name="emailVenueNameText"
					[(ngModel)]="eGiftVenue.emailVenueName"
					class="w-100"
					(change)="changesToSaveChange.emit(true)"
				/>
				<label for="emailVenueNameText">Email Venue Name</label>
			</span>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<input
					#emailVenueUrlText
					pInputText
					type="text"
					name="emailVenueUrlText"
					[(ngModel)]="eGiftVenue.emailVenueUrl"
					class="w-100"
					(change)="changesToSaveChange.emit(true)"
				/>
				<label for="emailVenueUrlText">Email Link URL</label>
			</span>
		</div>
		<div class="mt-4">
			<span class="p-float-label">
				<textarea
					#emailCustomMessageText
					pInputTextarea
					[(ngModel)]="eGiftVenue.emailCustomMessage"
					[maxlength]="500"
					style="height: 100px; width: 100%"
					(change)="changesToSaveChange.emit(true)"
				></textarea>
				<label for="emailCustomMessageText">Email Custom Message</label>
			</span>
		</div>
	</div>
	<div class="p-col-12 p-md-4">
		<div class="d-flex">
			<div class="h3">Web Page Header Image</div>
		</div>
		<p-divider></p-divider>
		<img
			class="w-100 mb-3"
			[src]="logoSrc + '?' + timestamp"
			onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueSvc.venueKey +'/logo.jpg?' + timestamp"
		/>
		<div class="mb-3">
			<p-button pRipple styleClass="p-button-raised w-100" (click)="selectImage('egiftLogo')">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
					Edit Web Page Header Image
				</ng-template>
			</p-button>
		</div>
		<div class="d-flex mt-4">
			<div class="h3">Email Header Image</div>
		</div>
		<p-divider></p-divider>
		<img
			class="w-100 mb-3"
			[src]="emailLogoSrc + '?' + timestamp"
			onError="this.src='https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/' + venueSvc.venueKey +'/logo.jpg?' + timestamp"
		/>
		<div class="mb-3">
			<p-button pRipple styleClass="p-button-raised w-100" (click)="selectImage('egiftEmailLogo')">
				<ng-template pTemplate="content">
					<fa-icon [icon]="['far', 'images']" size="lg" class="ms-1 me-2"></fa-icon>
					Edit Email Header Image
				</ng-template>
			</p-button>
		</div>
	</div>
</div>
